export default "__VITE_ASSET__D72jmC2H__"